import React, { useState } from "react";
import "./css/Header.css";
import { useCart } from "../../components/CartContext";
import { useNavigate, useParams } from "react-router-dom";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  const {
    restaurantId,
    tableId,
  } = useParams();

  const { cartCount } = useCart();


  // =====================================================
  // CLOSE MOBILE MENU
  // =====================================================

  const closeMobileMenu = () => {
    setMenuOpen(false);
  };


  // =====================================================
  // GO TO HOME
  // =====================================================

  const goToHome = () => {
    closeMobileMenu();

    const homePath =
      `/${restaurantId}/table/${tableId}`;

    const isHomePage =
      window.location.pathname === homePath;

    if (isHomePage) {

      // Already on HomeScreen
      // Just scroll to top

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      // Remove hash from URL

      window.history.pushState(
        {},
        "",
        homePath
      );

      return;
    }

    // Coming from Cart / Checkout / Order /
    // Payment / Success

    navigate(homePath);
  };


  // =====================================================
  // GO TO HOME SECTION
  // =====================================================

  const goToSection = (section) => {
    closeMobileMenu();

    const homePath =
      `/${restaurantId}/table/${tableId}`;

    const isHomePage =
      window.location.pathname === homePath;


    // ===================================================
    // ALREADY ON HOME SCREEN
    // ===================================================

    if (isHomePage) {

      const element =
        document.getElementById(section);

      if (element) {

        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      }

      // Update URL without reloading page

      window.history.pushState(
        {},
        "",
        `${homePath}#${section}`
      );

      return;
    }


    // ===================================================
    // COMING FROM ANOTHER PAGE
    // ===================================================

    navigate(
      `${homePath}#${section}`
    );


    // Wait for HomeScreen to render

    setTimeout(() => {

      const element =
        document.getElementById(section);

      if (element) {

        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      }

    }, 150);
  };


  // =====================================================
  // CONTACT
  // =====================================================

  const scrollToContact = () => {
    goToSection("contact");
  };


  // =====================================================
  // OPEN CART
  // =====================================================

  const openCart = () => {
    closeMobileMenu();

    navigate(
      `/${restaurantId}/table/${tableId}/cart`
    );
  };


  return (
    <header className="restaurant-header">

      <div className="header-container">


        {/* =================================================
            LOGO
        ================================================= */}

        <a
          href={`/${restaurantId}/table/${tableId}`}
          className="restaurant-logo"
          onClick={(event) => {
            event.preventDefault();
            goToHome();
          }}
        >

          <div className="logo-circle">
            <span>♧</span>
          </div>

          <div className="logo-text">

            <div className="logo-name">
              TASTY BITE
            </div>

            <div className="logo-subtitle">
              RESTAURANT
            </div>

          </div>

        </a>


        {/* =================================================
            NAVIGATION
        ================================================= */}

        <nav
          className={`header-nav ${
            menuOpen ? "mobile-open" : ""
          }`}
        >


          {/* HOME */}

          <a
            href={`/${restaurantId}/table/${tableId}`}
            onClick={(event) => {
              event.preventDefault();
              goToHome();
            }}
          >
            Home
          </a>


          {/* MENU */}

          <a
            href={`/${restaurantId}/table/${tableId}#menu`}
            onClick={(event) => {
              event.preventDefault();
              goToSection("menu");
            }}
          >
            Menu
          </a>


          {/* ABOUT */}

          <a
            href={`/${restaurantId}/table/${tableId}#about`}
            onClick={(event) => {
              event.preventDefault();
              goToSection("about");
            }}
          >
            About
          </a>


          {/* GALLERY */}

          <a
            href={`/${restaurantId}/table/${tableId}#gallery`}
            onClick={(event) => {
              event.preventDefault();
              goToSection("gallery");
            }}
          >
            Gallery
          </a>


          {/* CONTACT */}

          <a
            href={`/${restaurantId}/table/${tableId}#contact`}
            onClick={(event) => {
              event.preventDefault();
              goToSection("contact");
            }}
          >
            Contact
          </a>

        </nav>


        {/* =================================================
            HEADER ACTIONS
        ================================================= */}

        <div className="header-actions">


          {/* CART */}

          <button
            type="button"
            className="header-cart-button"
            onClick={openCart}
          >

            <span className="cart-icon">
              🛒
            </span>

            <span className="cart-text">
              Cart
            </span>

            <span className="cart-count">
              {cartCount}
            </span>

          </button>

        </div>


        {/* =================================================
            MOBILE MENU
        ================================================= */}

        <button
          type="button"
          className="mobile-menu-button"
          onClick={() =>
            setMenuOpen(!menuOpen)
          }
          aria-label={
            menuOpen
              ? "Close navigation menu"
              : "Open navigation menu"
          }
          aria-expanded={menuOpen}
        >

          {menuOpen ? "✕" : "☰"}

        </button>

      </div>

    </header>
  );
}